import { PlugZap } from 'lucide-react'

/**
 * Shown where a live R2 feed would render but Andrew hasn't pointed the env var at
 * his bucket yet. Keeps the app fully demoable without the content layer wired.
 */
export function ConfigHint({ envVar, what }: { envVar: string; what: string }) {
  return (
    <div className="confighint">
      <PlugZap size={20} />
      <p>
        Connect {what} by setting <code>{envVar}</code>
        <br />
        (and <code>VITE_R2_BASE_URL</code>) to your R2 feed.
      </p>
    </div>
  )
}
